<template>
    <el-dialog
        :visible.sync="dialogVisible"
        title="还原"
        :close-on-press-escape="false"
        width="600px"
        append-to-body
        :before-close="handleClose">
        <el-form ref="form" :rules="rules" :model="formItem" label-width="120px" class="pr40">
            <el-form-item label="还原到部门：" prop="group_id" class="label-required">
                <TreeSelect
                    :options="departmentData"
                    v-model="formItem.group_id"
                    :normalizer="normalizer"
                    @select="selectDepartment"
                    @open="treeOpen"
                    :defaultExpandLevel="3"
                    placeholder="请选择要还原的部门"
                    noResultsText="暂无数据"
                    noOptionsText="暂无可用数据"
                    class="font12px"
                >
                    <label slot="option-label" slot-scope="{ node}">
                        <span :class="getLabelClassName(node)">{{ node.label }}</span>
                    </label>
                </TreeSelect>
            </el-form-item>
            <el-form-item label="角色：" prop="role_ids" class="label-required">
                <ESelect v-model="formItem.role_ids" ref="roleSelect" multiple class="full-w" placeholder="请选择角色">
                    <el-option
                        v-for="item in roleList"
                        :key="item.id"
                        :label="item.role_name"
                        :value="item.id">
                    </el-option>
                </ESelect>
            </el-form-item>

        </el-form>

        <div slot="footer" class="dialog-footer tac">
            <el-button type="default" @click="handleClose" class="action-btn mr20">取消</el-button>
            <el-button type="primary" @click="handleSubmit" :loading="submitLoading" class="action-btn ml20">保存</el-button>
        </div>
    </el-dialog>
</template>

<script>
    import TreeSelect from '@riophae/vue-treeselect'
    import '@riophae/vue-treeselect/dist/vue-treeselect.css'
    import API from '@/api/department.js';

    export default {
        name: "MemberDepartmentModal",
        components:{
            TreeSelect,
        },
        props:{
            user:{
                required:true,
                type:Object,
            },
        },
        data() {
            return {
                submitLoading:false,
                dialogVisible: false,
                formItem: {
                    group_id:null,
                    role_ids:[],
                },
                oldGroupId:'',      //用来记录上一次选择的部门
                rules:{
                    group_id: [
                        {required: true, message: '请选择归属部门', trigger: 'blur'},
                    ],
                    role_ids:[
                        {type:'array',required: true, message: '请选择角色', trigger: 'blur'},
                    ],
                },
                departmentData: [],
                roleList:[],
                normalizer(node) {
                    return {
                        id: node.id,
                        label: node.name,
                        children: node.children,
                    }
                },
            }
        },
        methods: {
            handleClose() {
                this.dialogVisible = false;
                this.resetForm();
            },
            showModal() {
                this.dialogVisible = true;
                this.getDepartmentTree();
                this.getRoleList();
                this.$nextTick(()=>{
                    this.formItem.group_id = this.user.group_id;
                    this.oldGroupId = this.user.group_id;
                })
            },
            resetForm() {
                this.submitLoading = false;
                this.formItem.role_ids = [];
                this.$refs['form'].resetFields();
            },
            getDepartmentTree(){
                API.getTree().then(res => {
                    this.departmentData = [res.data];
                }, (err) => {
                    console.log('getDepartmentTree error', err);
                    this.departmentData = [];
                });
            },
            getRoleList(){
                API.getRoleList().then(res => {
                    this.roleList = res.data || [];
                }, (err) => {
                    console.log('getUserList error', err);
                    this.roleList = [];
                });
            },
            handleSubmit(){
                this.$refs['form'].validate((valid) => {
                    if (valid) {
                        API.userRestore({
                            id:this.user.id,
                            group_id:this.formItem.group_id,
                            role_ids:this.formItem.role_ids,
                        }).then(res => {
                            this.$message.success(res.info || '操作成功');
                            this.dialogVisible = false;
                            this.resetForm();
                            this.$emit('update');
                        }, (err) => {
                            console.log('userRestore error', err);
                            this.$message.error(err.info || '操作失败');
                            this.submitLoading = false;
                        });

                    } else {
                        return false;
                    }
                });
            },
            treeOpen(){
                this.$refs.roleSelect.blur();
            },
            getLabelClassName(node){
                let rawNode = node.raw||{};
                return rawNode.disable?"option-label-disabled":'';
            },
            selectDepartment(node){
                if(node.disable){
                    this.$message.error(`【${node.name}】不可选择`);
                    this.$nextTick(()=>{
                        this.formItem.group_id = this.oldGroupId;
                    })
                }else{
                    this.oldGroupId = node.id;
                }
            },
        }
    }
</script>

<style scoped>
    .action-btn {
        width: 120px;
    }
    .option-label-disabled{
        color: #bbb;
        cursor: not-allowed;
        display: inline-block;
        width: 100%;
    }
</style>
